import React from 'react'
import {
  Link,
  IconButton,
  Divider,
  ListItem,
  ListItemIcon,
  ListItemText,
  List
} from '@material-ui/core'
import PowerSettingsNewOutlinedIcon from '@material-ui/icons/PowerSettingsNewOutlined'
import SettingsEthernetOutlinedIcon from '@material-ui/icons/SettingsEthernetOutlined'
import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined'
import AttachMoneyOutlinedIcon from '@material-ui/icons/AttachMoneyOutlined'
import BlurOnOutlinedIcon from '@material-ui/icons/BlurOnOutlined'
import CreateOutlinedIcon from '@material-ui/icons/CreateOutlined'
import DeveloperBoardOutlinedIcon from '@material-ui/icons/DeveloperBoardOutlined'
import DonutLargeIcon from '@material-ui/icons/DonutLarge'
import { Theme } from '../../styles'

const csrfToken = ''

export const AdminMenuList = () => {
  return (
    <div>
      <Divider />
      <List className="list-style">
        <li>
          <Link className="link-style" href="/portal/index">
            <ListItem button key="Portal">
              <ListItemIcon className="icon">
                <BlurOnOutlinedIcon />
              </ListItemIcon>
              <ListItemText primary="Portal" />
            </ListItem>
          </Link>
          <Link className="link-style" href="/admin/treasury">
            <ListItem button key="Finance">
              <ListItemIcon className="icon">
                <AttachMoneyOutlinedIcon />
              </ListItemIcon>
              <ListItemText primary="Finance" />
            </ListItem>
          </Link>
          <Link className="link-style" href="/admin/users">
            <ListItem button key="Users">
              <ListItemIcon className="icon">
                <AccountCircleOutlinedIcon />
              </ListItemIcon>
              <ListItemText primary="Users" />
            </ListItem>
          </Link>
          <Divider />
          <Link className="link-style" href="/devops/index">
            <ListItem button key="DevOps">
              <ListItemIcon className="icon">
                <SettingsEthernetOutlinedIcon />
              </ListItemIcon>
              <ListItemText primary="DevOps" />
            </ListItem>
          </Link>
          <Link className="link-style" href="/devops/api">
            <ListItem button key="Engine">
              <ListItemIcon className="icon">
                <DeveloperBoardOutlinedIcon />
              </ListItemIcon>
              <ListItemText primary="Engine" />
            </ListItem>
          </Link>
          <Link className="link-style" href="/devops/forms">
            <ListItem button key="Forms">
              <ListItemIcon className="icon">
                <CreateOutlinedIcon />
              </ListItemIcon>
              <ListItemText primary="Forms" />
            </ListItem>
          </Link>

          <Divider />
          <Link className="link-style" href="/processes">
            <ListItem button key="Processes">
              <ListItemIcon className="icon">
                <DonutLargeIcon />
              </ListItemIcon>
              <ListItemText primary="Processes" />
            </ListItem>
          </Link>
          <Divider />

          <ListItem button key="Toggle Theme">
            <ListItemIcon className="icon">
              <Theme />
            </ListItemIcon>
            <ListItemText primary="Toggle Theme" />
          </ListItem>

          <form action="/auth/logout" method="POST">
            <input type="hidden" name="_token" value={csrfToken} />
            <ListItem button key="Logout">
              <ListItemIcon className="icon">
                <IconButton
                  style={{ color: '#e3342f', left: '-3px' }}
                  size="small"
                  aria-label="logout"
                  type="submit">
                  <PowerSettingsNewOutlinedIcon />
                </IconButton>
              </ListItemIcon>
              <ListItemText
                style={{ color: '#e3342f', paddingLeft: '0px' }}
                primary="Logout"
              />
            </ListItem>
          </form>
        </li>
      </List>
    </div>
  )
}

export default AdminMenuList
